// Shared browser/build configuration, with business facts stored in one JSON file.
const business = require('./business.json');
const configuredUrl = process.env.REACT_APP_SITE_URL;
if (!configuredUrl) throw new Error('REACT_APP_SITE_URL is required');
const parsedUrl = new URL(configuredUrl);
if (!['http:', 'https:'].includes(parsedUrl.protocol) || parsedUrl.username || parsedUrl.password) {
  throw new Error('REACT_APP_SITE_URL must be a public HTTP(S) origin');
}
const SITE_URL = parsedUrl.origin;
const businessReference = { '@id': `${SITE_URL}/#organization` };
const businessSchema = {
  '@context': 'https://schema.org', '@type': 'LocalBusiness', ...businessReference,
  ...business, url: `${SITE_URL}/`,
  logo: `${SITE_URL}/seo-images/groundhogs-logo.png`,
  image: `${SITE_URL}/seo-images/f69s3hj7_sep.webp`
};
const websiteSchema = {
  '@context': 'https://schema.org', '@type': 'WebSite', '@id': `${SITE_URL}/#website`,
  url: `${SITE_URL}/`, name: business.name, alternateName: business.alternateName,
  publisher: businessReference
};
const serializeSchema = (data) => JSON.stringify(data).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
module.exports = { SITE_URL, business, businessSchema, websiteSchema, businessReference, serializeSchema };